var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10C27.2614 10 29.5 7.76142 29.5 5C29.5 2.23858 27.2614 0 24.5 0C21.7386 0 19.5 2.23858 19.5 5C19.5 7.76142 21.7386 10 24.5 10Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9351 15.0649C40.4203 15.0649 42.4351 13.0502 42.4351 10.5649C42.4351 8.07966 40.4203 6.06494 37.9351 6.06494C35.4498 6.06494 33.4351 8.07966 33.4351 10.5649C33.4351 13.0502 35.4498 15.0649 37.9351 15.0649Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 28C45.7091 28 47.5 26.2091 47.5 24C47.5 21.7909 45.7091 20 43.5 20C41.2909 20 39.5 21.7909 39.5 24C39.5 26.2091 41.2909 28 43.5 28Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9351 40.9351C39.8681 40.9351 41.4351 39.3681 41.4351 37.4351C41.4351 35.5021 39.8681 33.9351 37.9351 33.9351C36.0021 33.9351 34.4351 35.5021 34.4351 37.4351C34.4351 39.3681 36.0021 40.9351 37.9351 40.9351Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 46C26.1569 46 27.5 44.6569 27.5 43C27.5 41.3431 26.1569 40 24.5 40C22.8431 40 21.5 41.3431 21.5 43C21.5 44.6569 22.8431 46 24.5 46Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0649 39.9351C12.4457 39.9351 13.5649 38.8158 13.5649 37.4351C13.5649 36.0543 12.4457 34.9351 11.0649 34.9351C9.68423 34.9351 8.56494 36.0543 8.56494 37.4351C8.56494 38.8158 9.68423 39.9351 11.0649 39.9351Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 26C6.60457 26 7.5 25.1046 7.5 24C7.5 22.8954 6.60457 22 5.5 22C4.39543 22 3.5 22.8954 3.5 24C3.5 25.1046 4.39543 26 5.5 26Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0649 12.0649C11.8934 12.0649 12.5649 11.3934 12.5649 10.5649C12.5649 9.73651 11.8934 9.06494 11.0649 9.06494C10.2365 9.06494 9.56494 9.73651 9.56494 10.5649C9.56494 11.3934 10.2365 12.0649 11.0649 12.0649Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.56a1af9c24465fab8d2707c6e584d12d.svg";
export { ForwardRef as ReactComponent };